/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_EnergyInputs */

const en_us2_workout_after_energy = /** @type {(inputs: Workout_After_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is your energy, from 1 to 5?`)
};

const pt_br2_workout_after_energy = /** @type {(inputs: Workout_After_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como está a energia, de 1 a 5?`)
};

const es_419_workout_after_energy = /** @type {(inputs: Workout_After_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo está tu energía, del 1 al 5?`)
};

const pt_pt2_workout_after_energy = /** @type {(inputs: Workout_After_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como está a energia, de 1 a 5?`)
};

const fr_fr2_workout_after_energy = /** @type {(inputs: Workout_After_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton énergie, de 1 à 5 ?`)
};

const de_de2_workout_after_energy = /** @type {(inputs: Workout_After_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie ist deine Energie, von 1 bis 5?`)
};

const it_it2_workout_after_energy = /** @type {(inputs: Workout_After_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com'è la tua energia, da 1 a 5?`)
};

/**
* | output |
* | --- |
* | "How is your energy, from 1 to 5?" |
*
* @param {Workout_After_EnergyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_energy = /** @type {((inputs?: Workout_After_EnergyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_EnergyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_energy(inputs)
	if (locale === "es-419") return es_419_workout_after_energy(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_energy(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_energy(inputs)
	if (locale === "de-DE") return de_de2_workout_after_energy(inputs)
	if (locale === "it-IT") return it_it2_workout_after_energy(inputs)
	return en_us2_workout_after_energy(inputs)
});
export { workout_after_energy as "workout-after.energy" }